import styled from '@emotion/styled';
import { rem } from '@utils';

const Wrapper = styled.div`
  width: 100%;
`;

const ChartArea = styled.div`
  border-radius: ${rem(6)};
  height: ${rem(44)};
  overflow: hidden;
  width: 100%;
`;

const ValueRow = styled.div`
  display: flex;
  width: 100%;
`;

const ValueItem = styled.div<{ width: number }>`
  flex: 0 0 ${({ width }) => `${width}%`};
  min-width: 0;
  text-align: center;
`;

const ValueSpacer = styled.div<{ width: number }>`
  flex: 0 0 ${({ width }) => `${width}%`};
`;

const ValueText = styled.span`
  color: ${({ theme }) => theme.palette.common.black};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${rem(10)};
  font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
  line-height: ${rem(14)};
  margin: 0;
  white-space: nowrap;
`;

export default {
  Wrapper,
  ChartArea,
  ValueRow,
  ValueItem,
  ValueSpacer,
  ValueText
};
